/* Page geometry, story text and the printed layout for the personalized builder. GENERATED by
   backend/scripts/personalized_builder_assets.py (Pediment OS) from the book's manifest, book_spec and document.py
   on 2026-10-12 (manifest version 4).
   Do not edit by hand. BOOK_PAGES boxes are % of the trimmed art; text boxes and elements are in book points. */
window.BOOK_PAGES = [
 {
  "id": "cover",
  "w": 1578,
  "h": 2029,
  "box": [
   7.67,
   40.78,
   88.33,
   107.71
  ]
 },
 {
  "id": "p01",
  "w": 2271,
  "h": 2938,
  "box": [
   34.88,
   57.42,
   66.33,
   95.4
  ]
 },
 {
  "id": "p02-03",
  "w": 3482,
  "h": 2253,
  "box": [
   69.1,
   9.43,
   86.13,
   88.09
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 54.0,
     "w": 375.998,
     "h": 275.998,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "I believe what it says in The Book.\nSix days the Lord it took.",
       "gap": 14
      },
      {
       "text": "To create this world\nand all that we see,",
       "gap": 14
      },
      {
       "text": "Every bird, fish and mammal.\nEvery bush, every tree.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "I believe what it says in The Book.\nSix days the Lord it took.",
     "To create this world\nand all that we see,",
     "Every bird, fish and mammal.\nEvery bush, every tree."
    ],
    "box": [
     54,
     54,
     376,
     276
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p04-05",
  "w": 3482,
  "h": 2253,
  "box": [
   63.47,
   22.88,
   83.43,
   67.44
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 72.0,
     "w": 486.0,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "On day one God created day and night.",
       "gap": 0
      },
      {
       "text": "He looked all around and saw it was right.",
       "gap": 0
      }
     ]
    },
    "lines": [
     "On day one God created day and night.",
     "He looked all around and saw it was right."
    ],
    "box": [
     72,
     54,
     486,
     120
    ],
    "tone": "navy",
    "display": false,
    "tight": true,
    "cite": null
   }
  ]
 },
 {
  "id": "p06-07",
  "w": 3482,
  "h": 2253,
  "hasChild": false,
  "text": [
   {
    "side": "R",
    "el": {
     "x": 100.001,
     "y": 72.0,
     "w": 457.999,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#f9efdb",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "shadow": "0 1.5pt 6pt rgba(27,52,89,.55)",
     "paras": [
      {
       "text": "The firmament or heavens\nwere made on day two.",
       "gap": 14
      },
      {
       "text": "At this point the earth\nwas still fresh and new.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "The firmament or heavens\nwere made on day two.",
     "At this point the earth\nwas still fresh and new."
    ],
    "box": [
     72,
     100,
     458,
     120
    ],
    "tone": "cream",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p08-09",
  "w": 3482,
  "h": 2253,
  "box": [
   68.35,
   14.44,
   88.14,
   67.31
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 72.0,
     "w": 457.999,
     "h": 275.998,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "On day three God got serious\nwith this business of creation,",
       "gap": 14
      },
      {
       "text": "He separated dry land from wet\nand made all vegetation.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "On day three God got serious\nwith this business of creation,",
     "He separated dry land from wet\nand made all vegetation."
    ],
    "box": [
     72,
     54,
     458,
     276
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p10-11",
  "w": 3482,
  "h": 2253,
  "box": [
   9.87,
   32.64,
   22.46,
   59.94
  ],
  "text": [
   {
    "side": "R",
    "el": {
     "x": 100.001,
     "y": 157.997,
     "w": 457.999,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#f9efdb",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "shadow": "0 1.5pt 6pt rgba(27,52,89,.55)",
     "paras": [
      {
       "text": "The sun, moon and stars\nwere made on day four.",
       "gap": 14
      },
      {
       "text": "But He didn't stop there.\nHe created much more.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "The sun, moon and stars\nwere made on day four.",
     "But He didn't stop there.\nHe created much more."
    ],
    "box": [
     158,
     100,
     458,
     120
    ],
    "tone": "cream",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p12-13",
  "w": 3482,
  "h": 2253,
  "box": [
   2.38,
   32.51,
   33.46,
   89.02
  ],
  "text": [
   {
    "side": "R",
    "el": {
     "x": 72.0,
     "y": 72.0,
     "w": 486.0,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "The birds and fish He made on day five.",
       "gap": 0
      },
      {
       "text": "Now the earth was really alive.",
       "gap": 0
      }
     ]
    },
    "lines": [
     "The birds and fish He made on day five.",
     "Now the earth was really alive."
    ],
    "box": [
     72,
     72,
     486,
     120
    ],
    "tone": "navy",
    "display": false,
    "tight": true,
    "cite": null
   }
  ]
 },
 {
  "id": "p14-15",
  "w": 3482,
  "h": 2253,
  "box": [
   76.65,
   53.42,
   84.84,
   91.64
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 72.0,
     "w": 486.0,
     "h": 149.998,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "After these five days\nthere was just the right mix",
       "gap": 14
      },
      {
       "text": "for his final creation\nto take place on day six.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "After these five days\nthere was just the right mix",
     "for his final creation\nto take place on day six."
    ],
    "box": [
     72,
     54,
     486,
     150
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   },
   {
    "side": "R",
    "el": {
     "x": 72.0,
     "y": 72.0,
     "w": 486.0,
     "h": 149.998,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "He made the beasts of the earth\nand animals for grazing",
       "gap": 14
      },
      {
       "text": "But then he did something\nthat was truly amazing.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "He made the beasts of the earth\nand animals for grazing",
     "But then he did something\nthat was truly amazing."
    ],
    "box": [
     72,
     72,
     486,
     150
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p16-17",
  "w": 3482,
  "h": 2253,
  "hasChild": false,
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 59.998,
     "w": 486.0,
     "h": 149.998,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "In His own image\nhe created with clay",
       "gap": 14
      },
      {
       "text": "His most precious possession\non this, the sixth day.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "In His own image\nhe created with clay",
     "His most precious possession\non this, the sixth day."
    ],
    "box": [
     60,
     54,
     486,
     150
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p18-19",
  "w": 3482,
  "h": 2253,
  "box": [
   23.46,
   16.44,
   36.18,
   57.32
  ],
  "text": [
   {
    "side": "R",
    "el": {
     "x": 100.001,
     "y": 100.001,
     "w": 457.999,
     "h": 180.0,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "He created mankind\nto rule over it all,",
       "gap": 14
      },
      {
       "text": "Every fish, bird and beast\nfrom the great to the small.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "He created mankind\nto rule over it all,",
     "Every fish, bird and beast\nfrom the great to the small."
    ],
    "box": [
     100,
     100,
     458,
     180
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p20-21",
  "w": 3482,
  "h": 2253,
  "box": [
   76.17,
   29.27,
   97.28,
   60.79
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 72.0,
     "w": 486.0,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "On day seven God rested,\nkicked back, took a break.",
       "gap": 14
      },
      {
       "text": "Wouldn't you need a rest\nwith all this stuff to make?",
       "gap": 14
      }
     ]
    },
    "lines": [
     "On day seven God rested,\nkicked back, took a break.",
     "Wouldn't you need a rest\nwith all this stuff to make?"
    ],
    "box": [
     72,
     54,
     486,
     120
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p22-23",
  "w": 3482,
  "h": 2253,
  "box": [
   -1.36,
   12.45,
   35.41,
   101.14
  ],
  "text": [
   {
    "side": "R",
    "el": {
     "x": 100.001,
     "y": 120.002,
     "w": 457.999,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "So this is the way\nI believe it took place",
       "gap": 14
      },
      {
       "text": "It's as clear and as plain\nas the nose on my face.",
       "gap": 14
      }
     ]
    },
    "lines": [
     "So this is the way\nI believe it took place",
     "It's as clear and as plain\nas the nose on my face."
    ],
    "box": [
     120,
     100,
     458,
     120
    ],
    "tone": "navy",
    "display": false,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p24-25",
  "w": 3482,
  "h": 2253,
  "box": [
   8.21,
   28.69,
   24.12,
   80.32
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 72.0,
     "w": 486.0,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "God made all that we know\nand all that we see",
       "gap": 0
      }
     ]
    },
    "lines": [
     "God made all that we know\nand all that we see"
    ],
    "box": [
     72,
     54,
     486,
     120
    ],
    "tone": "navy",
    "display": false,
    "tight": true,
    "cite": null
   },
   {
    "side": "R",
    "el": {
     "x": 72.0,
     "y": 72.0,
     "w": 360.0,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "He made dogs, cats and buffalo —\nhe even made me.",
       "gap": 0
      }
     ]
    },
    "lines": [
     "He made dogs, cats and buffalo —\nhe even made me."
    ],
    "box": [
     72,
     72,
     360,
     120
    ],
    "tone": "navy",
    "display": false,
    "tight": true,
    "cite": null
   }
  ]
 },
 {
  "id": "p26-27",
  "w": 3482,
  "h": 2253,
  "box": [
   24.98,
   38.73,
   41.33,
   70.95
  ],
  "name_area": [
   60.83,
   75.57,
   97.28,
   82.4
  ],
  "text": [
   {
    "side": "R",
    "el": {
     "x": 100.001,
     "y": 72.0,
     "w": 457.999,
     "h": 120.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "He made vegetables and fruit —\nyes, broccoli and grapes!",
       "gap": 0
      }
     ]
    },
    "lines": [
     "He made vegetables and fruit —\nyes, broccoli and grapes!"
    ],
    "box": [
     72,
     100,
     458,
     120
    ],
    "tone": "navy",
    "display": false,
    "tight": true,
    "cite": null
   }
  ]
 },
 {
  "id": "p28-29",
  "w": 3482,
  "h": 2253,
  "box": [
   68.24,
   2.41,
   85.62,
   96.56
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 77.998,
     "w": 462.002,
     "h": 416.002,
     "font": "story",
     "weight": 500,
     "size": 40,
     "lead": 48,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "God is my creator.",
       "gap": 16
      },
      {
       "text": "I did not come\nfrom apes!",
       "gap": 16
      }
     ]
    },
    "lines": [
     "God is my creator.",
     "I did not come\nfrom apes!"
    ],
    "box": [
     78,
     54,
     462,
     416
    ],
    "tone": "navy",
    "display": true,
    "tight": false,
    "cite": null
   }
  ]
 },
 {
  "id": "p30-31",
  "w": 3482,
  "h": 2253,
  "box": [
   63.33,
   10.63,
   90.61,
   101.14
  ],
  "text": [
   {
    "side": "L",
    "el": {
     "x": 54.0,
     "y": 72.0,
     "w": 468.0,
     "h": 200.002,
     "font": "story",
     "weight": 500,
     "size": 24,
     "lead": 32,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "balance": true,
     "paras": [
      {
       "text": "God made {N},",
       "gap": 0
      },
      {
       "text": "fearfully and wonderfully made.",
       "gap": 16
      },
      {
       "text": "Psalm 139:14",
       "gap": 0,
       "size": 15,
       "lead": 20,
       "ls": 0.08
      }
     ]
    },
    "lines": [
     "God made {N},",
     "fearfully and wonderfully made."
    ],
    "box": [
     72,
     54,
     468,
     200
    ],
    "tone": "navy",
    "display": false,
    "tight": true,
    "cite": "Psalm 139:14"
   }
  ],
  "variants": {
   "boy": {
    "w": 3482,
    "h": 2253,
    "box": [
     60.14,
     10.18,
     98.51,
     81.78
    ],
    "art": "ph-p30-31-boy",
    "text": [
     {
      "side": "L",
      "el": {
       "x": 54.0,
       "y": 72.0,
       "w": 468.0,
       "h": 200.002,
       "font": "story",
       "weight": 500,
       "size": 24,
       "lead": 32,
       "color": "#1b3459",
       "align": "left",
       "ls": 0.0,
       "balance": true,
       "paras": [
        {
         "text": "God made {N},",
         "gap": 0
        },
        {
         "text": "fearfully and wonderfully made.",
         "gap": 16
        },
        {
         "text": "Psalm 139:14",
         "gap": 0,
         "size": 15,
         "lead": 20,
         "ls": 0.08
        }
       ]
      },
      "lines": [
       "God made {N},",
       "fearfully and wonderfully made."
      ],
      "box": [
       72,
       54,
       468,
       200
      ],
      "tone": "navy",
      "display": false,
      "tight": true,
      "cite": "Psalm 139:14"
     }
    ]
   }
  }
 }
];
window.BOOK_LAYOUT = {
 "fonts": {
  "story": {
   "family": "Outfit",
   "files": [
    "Outfit-Medium.ttf",
    "Outfit-Bold.ttf"
   ]
  },
  "display": {
   "family": "Cabin Sketch",
   "files": [
    "CabinSketch-Bold.ttf"
   ]
  }
 },
 "page_pt": [
  612.0,
  792.0
 ],
 "cover_pt": [
  630.0,
  810.0
 ],
 "title": {
  "els": [
   {
    "x": 0.0,
    "y": 95.998,
    "w": 612.0,
    "h": 128.002,
    "font": "display",
    "weight": 700,
    "size": 58,
    "lead": 64,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.0,
    "paras": [
     {
      "text": "I Did Not Come",
      "gap": 0,
      "size": 58
     },
     {
      "text": "From Apes",
      "gap": 0,
      "size": 74
     }
    ]
   },
   {
    "x": 0.0,
    "y": 265.997,
    "w": 612.0,
    "h": 23.998,
    "font": "story",
    "weight": 500,
    "size": 19,
    "lead": 24.0,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.0,
    "paras": [
     {
      "text": "by Christopher Fenison",
      "gap": 0
     }
    ]
   },
   {
    "x": 0.0,
    "y": 321.998,
    "w": 612.0,
    "h": 21.751,
    "font": "story",
    "weight": 500,
    "size": 17,
    "lead": 21.75,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.03,
    "paras": [
     {
      "text": "Made especially for {N}",
      "gap": 0
     }
    ]
   },
   {
    "x": 72.0,
    "y": 352.001,
    "w": 468.0,
    "h": 21.002,
    "font": "story",
    "weight": 500,
    "size": 15,
    "lead": 21,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.03,
    "paras": [
     {
      "text": "{DED}",
      "gap": 0
     }
    ]
   },
   {
    "x": 36.0,
    "y": 373.003,
    "w": 540.0,
    "h": 21.002,
    "font": "story",
    "weight": 500,
    "size": 15,
    "lead": 21,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.03,
    "paras": [
     {
      "text": "{FROM}",
      "gap": 0
     }
    ]
   }
  ],
  "name": 2,
  "dedication": 3,
  "from": 4,
  "name_fit": {
   "min": 12,
   "step": 0.5,
   "width": 540
  },
  "dedication_lines": 3,
  "dedication_max": 90,
  "from_max": 60,
  "wrap_slack": 8
 },
 "cover": {
  "els": [
   {
    "x": 36.0,
    "y": 50.4,
    "w": 558.0,
    "h": 153.0,
    "font": "display",
    "weight": 700,
    "size": 64,
    "lead": 68,
    "color": "#ffffff",
    "align": "center",
    "ls": 0.0,
    "shadow": "0 2pt 8pt rgba(27,52,89,.6)",
    "paras": [
     {
      "text": "I Did Not Come",
      "gap": 0
     },
     {
      "text": "From Apes",
      "gap": 0,
      "size": 81,
      "lead": 85
     }
    ]
   },
   {
    "x": 36.0,
    "y": 220.306,
    "w": 558.0,
    "h": 36.0,
    "font": "story",
    "weight": 500,
    "size": 21,
    "lead": 26.25,
    "color": "#ffffff",
    "align": "center",
    "ls": 0.0,
    "shadow": "0 2pt 8pt rgba(27,52,89,.6)",
    "paras": [
     {
      "text": "{N} discovers how {she} was made",
      "gap": 0
     }
    ]
   }
  ]
 },
 "recap": {
  "L": {
   "art": "bm-p32",
   "els": [
    {
     "x": 54.0,
     "y": 54.0,
     "w": 558.0,
     "h": 59.998,
     "font": "display",
     "weight": 700,
     "size": 48,
     "lead": 56.25,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "The Seven Days",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 175.997,
     "w": 300.002,
     "h": 40.003,
     "font": "display",
     "weight": 700,
     "size": 30,
     "lead": 35.25,
     "color": "#e86e5a",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day 1",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 213.998,
     "w": 300.002,
     "h": 48.002,
     "font": "story",
     "weight": 500,
     "size": 19,
     "lead": 24,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day and night",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 324.0,
     "w": 300.002,
     "h": 40.003,
     "font": "display",
     "weight": 700,
     "size": 30,
     "lead": 35.25,
     "color": "#e86e5a",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day 2",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 362.002,
     "w": 300.002,
     "h": 48.002,
     "font": "story",
     "weight": 500,
     "size": 19,
     "lead": 24,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "The sky above",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 472.003,
     "w": 300.002,
     "h": 40.003,
     "font": "display",
     "weight": 700,
     "size": 30,
     "lead": 35.25,
     "color": "#e86e5a",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day 3",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 509.998,
     "w": 300.002,
     "h": 48.002,
     "font": "story",
     "weight": 500,
     "size": 19,
     "lead": 24,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Dry land and every plant",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 619.999,
     "w": 300.002,
     "h": 40.003,
     "font": "display",
     "weight": 700,
     "size": 30,
     "lead": 35.25,
     "color": "#e86e5a",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day 4",
       "gap": 0
      }
     ]
    },
    {
     "x": 203.998,
     "y": 658.001,
     "w": 300.002,
     "h": 48.002,
     "font": "story",
     "weight": 500,
     "size": 19,
     "lead": 24,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Sun, moon and stars",
       "gap": 0
      }
     ]
    }
   ]
  },
  "R": {
   "art": "bm-p33",
   "els": [
    {
     "x": 221.998,
     "y": 175.997,
     "w": 300.002,
     "h": 40.003,
     "font": "display",
     "weight": 700,
     "size": 30,
     "lead": 35.25,
     "color": "#e86e5a",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day 5",
       "gap": 0
      }
     ]
    },
    {
     "x": 221.998,
     "y": 213.998,
     "w": 300.002,
     "h": 48.002,
     "font": "story",
     "weight": 500,
     "size": 19,
     "lead": 24,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Birds and fish",
       "gap": 0
      }
     ]
    },
    {
     "x": 221.998,
     "y": 324.0,
     "w": 300.002,
     "h": 40.003,
     "font": "display",
     "weight": 700,
     "size": 30,
     "lead": 35.25,
     "color": "#e86e5a",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day 6",
       "gap": 0
      }
     ]
    },
    {
     "x": 221.998,
     "y": 362.002,
     "w": 300.002,
     "h": 48.002,
     "font": "story",
     "weight": 500,
     "size": 19,
     "lead": 24,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Animals — and people, too!",
       "gap": 0
      }
     ]
    },
    {
     "x": 221.998,
     "y": 472.003,
     "w": 300.002,
     "h": 40.003,
     "font": "display",
     "weight": 700,
     "size": 30,
     "lead": 35.25,
     "color": "#e86e5a",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "Day 7",
       "gap": 0
      }
     ]
    },
    {
     "x": 221.998,
     "y": 509.998,
     "w": 300.002,
     "h": 48.002,
     "font": "story",
     "weight": 500,
     "size": 19,
     "lead": 24,
     "color": "#1b3459",
     "align": "left",
     "ls": 0.0,
     "paras": [
      {
       "text": "God rested",
       "gap": 0
      }
     ]
    },
    {
     "x": 72.0,
     "y": 619.999,
     "w": 486.0,
     "h": 79.999,
     "font": "story",
     "weight": 500,
     "size": 18,
     "lead": 25,
     "color": "#1b3459",
     "align": "center",
     "ls": 0.0,
     "paras": [
      {
       "text": "“And God saw every thing that he had made,\nand, behold, it was very good.”",
       "gap": 0
      },
      {
       "text": "— Genesis 1:31",
       "gap": 0,
       "size": 15,
       "lead": 27.22
      }
     ]
    }
   ]
  }
 },
 "back": {
  "art": "bm-p34",
  "els": [
   {
    "x": 54.0,
    "y": 64.001,
    "w": 486.0,
    "h": 63.0,
    "font": "story",
    "weight": 500,
    "size": 15,
    "lead": 21,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.0,
    "paras": [
     {
      "text": "For Dad, who helped me write it,\nand for my boys, whom God created\nin His image to do great things.",
      "gap": 0
     }
    ]
   },
   {
    "x": 54.0,
    "y": 372.002,
    "w": 486.0,
    "h": 40.003,
    "font": "display",
    "weight": 700,
    "size": 30,
    "lead": 35.25,
    "color": "#e86e5a",
    "align": "center",
    "ls": 0.0,
    "paras": [
     {
      "text": "About the Author",
      "gap": 0
     }
    ]
   },
   {
    "x": 54.0,
    "y": 416.002,
    "w": 486.0,
    "h": 156.002,
    "font": "story",
    "weight": 500,
    "size": 13.5,
    "lead": 19.5,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.0,
    "paras": [
     {
      "text": "Christopher Fenison is husband to a beautiful wife and father of four awesome boys. When he was in grade school, his class studied the theory of evolution. Christopher knew what the Bible says about how the world began, and he felt the truth deserved to be heard, too. With the help of his father, Brad, he wrote this poem and presented it in front of his class. Years later, that poem became this book.",
      "gap": 0
     }
    ]
   },
   {
    "x": 146.016,
    "y": 594.497,
    "w": 203.753,
    "h": 16.999,
    "font": "story",
    "weight": 500,
    "size": 13,
    "lead": 17,
    "color": "#1b3459",
    "align": "left",
    "ls": 0.0,
    "paras": [
     {
      "text": "Want to make your own? Go to ",
      "gap": 0
     }
    ]
   },
   {
    "x": 325.771,
    "y": 594.497,
    "w": 142.445,
    "h": 16.999,
    "font": "story",
    "weight": 700,
    "size": 13,
    "lead": 17,
    "color": "#e86e5a",
    "align": "left",
    "ls": 0.0,
    "paras": [
     {
      "text": "pediment.com/apes",
      "gap": 0
     }
    ]
   },
   {
    "x": 444.211,
    "y": 594.497,
    "w": 27.77,
    "h": 16.999,
    "font": "story",
    "weight": 500,
    "size": 13,
    "lead": 17,
    "color": "#1b3459",
    "align": "left",
    "ls": 0.0,
    "paras": [
     {
      "text": ".",
      "gap": 0
     }
    ]
   },
   {
    "x": 72.0,
    "y": 648.0,
    "w": 450.0,
    "h": 11.002,
    "font": "story",
    "weight": 700,
    "size": 8,
    "lead": 11,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.0,
    "paras": [
     {
      "text": "I Did Not Come From Apes",
      "gap": 0
     }
    ]
   },
   {
    "x": 72.0,
    "y": 659.002,
    "w": 450.0,
    "h": 76.997,
    "font": "story",
    "weight": 500,
    "size": 8,
    "lead": 11,
    "color": "#1b3459",
    "align": "center",
    "ls": 0.0,
    "paras": [
     {
      "text": "Copyright © 2026 by Christopher Fenison • All Rights Reserved\nNo part of this book may be reproduced, stored in a retrieval system or transmitted in any form or by any means, electronic, mechanical, photocopying, recording or otherwise without prior written permission of the copyright owner or the publisher.\nPersonalized edition for {N}. Scripture quotations from the King James Version.\nPublished by Pediment Publishing, Vancouver, WA",
      "gap": 0
     }
    ]
   }
  ]
 }
};
window.BOOK_ALLOW_BABY = true;
